export default __webpack_public_path__ + "static/media/transfer_active.071a5728.svg";